export const MY_VIDEOS_REQUEST = Symbol('MY_VIDEOS_REQUEST');
export const MY_VIDEOS_MOBILE_REQUEST = Symbol('MY_VIDEOS_MOBILE_REQUEST');
export const MY_VIDEO_REQUEST = Symbol('MY_VIDEO_REQUEST');
export const MY_VIDEO_SUCCESS = Symbol('MY_VIDEO_SUCCESS');
export const SHOW_DELETE_MY_VIDEO = Symbol('SHOW_DELETE_MY_VIDEO');
export const POST_DELETE = Symbol('POST_DELETE');
export const MY_VIDEOS_RESET = Symbol('MY_VIDEOS_RESET');
export const UPDATE_MY_VIDEO_RESPONSIBLE_USER = Symbol('UPDATE_MY_VIDEO_RESPONSIBLE_USER');
export const UPDATE_MY_VIDEO_UPLOADER = Symbol('UPDATE_MY_VIDEO_UPLOADER');

/**
 * @param {number} pageNum
 * @param {string} sorting
 * @param {number} userId
 * @return {{type: symbol, payload: {searchTerm, pageNum}}}
 */
export const myVideosRequestAction = (sorting, userId, perPage, pageNum = 1) => ({
  type: MY_VIDEOS_REQUEST,
  payload: { pageNum, sorting, perPage, userId },
});

export const myVideosRequestMobileAction = (sorting, userId, perPage, pageNum, prevVideos) => ({
  type: MY_VIDEOS_MOBILE_REQUEST,
  payload: { sorting, userId, perPage, pageNum, prevVideos },
});
/**
 * @param {string} videoId
 * @return {{type: symbol, payload: {videoId: *}}}
 */
export const myVideoRequestAction = (videoId) => ({
  type: MY_VIDEO_REQUEST,
  payload: { videoId },
});

/**
 * @param {*} video
 * @return {{type: symbol, payload: {video: *}}}
 */
export const myVideoSuccessAction = (video) => ({
  type: MY_VIDEO_SUCCESS,
  payload: { video },
});

export const updateMyVideoUploaderAction = (videoUploader) => ({
  type: UPDATE_MY_VIDEO_UPLOADER,
  payload: {
    videoUploader,
  },
});

export const updateMyVideoResponsibleUserAction = (responsibleUser) => ({
  type: UPDATE_MY_VIDEO_RESPONSIBLE_USER,
  payload: {
    responsibleUser,
  },
});

/**
 * @param {string|null} videoId
 * @returns {{type: symbol, payload: {videoId: *}}}
 */
export const markVideoForDeletionAction = (videoId) => ({
  type: SHOW_DELETE_MY_VIDEO,
  payload: { videoId },
});

/**
 * @param {number} pageNumber
 * @return {{type: symbol, payload: {deletedVideoId: *, pageNumber: *, focusedVideoId: *}}}
 */
export const postDeleteAction = (pageNumber) => ({
  type: POST_DELETE,
  payload: { pageNumber },
});

export const resetMyVideosAction = () => ({
  type: MY_VIDEOS_RESET,
  payload: {},
});
